import { useState } from "react";
import { z } from "zod";
import { Form } from "@/components/ui/form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TabsContent } from "@/components/ui/tabs";
import FormInputField from "@/components/lib/from-input-field";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { X } from "lucide-react";

function ClientDetailsTabs() {
  const form = useForm({
    resolver: zodResolver(dateSchema),
    defaultValues: {
      date: "",
    },
  });

  const [images, setImages] = useState([]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const previewImages = files.map((file) => ({
      url: URL.createObjectURL(file),
      file,
      id: Math.random().toString(36).substr(2, 9),
    }));
    setImages((prev) => [...prev, ...previewImages]);
  };

  const handleRemove = (id) => {
    setImages((prev) => prev.filter((img) => img.id !== id));
  };

  return (
    <TabsContent value="client-details">
      <Card className="mt-5 bg-cblack5">
        <CardHeader>
           <h2 className="text-lg">Client Details</h2>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <form className="flex flex-col gap-6">
              <div className="flex justify-between items-center w-full gap-5 flex-col md:flex-row">
                <FormInputField
                  name="fName"
                  style="bg-cblack7"
                  placeholder={"Enter Client full name"}
                  form={form}
                  type="text"
                  label={"First Name"}
                />
                <FormInputField
                  name="lName"
                  style="bg-cblack7"
                  placeholder={"Enter phone number"}
                  form={form}
                  type="text"
                  label={"Last Name"}
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                <FormInputField
                  name="phone-number"
                  style="bg-cblack7"
                  placeholder={"Enter phone number"}
                  form={form}
                  type="text"
                  label={"Phone Number"}
                />
                <FormInputField
                  name="email"
                  style="bg-cblack7"
                  placeholder={"Enter Email Address"}
                  form={form}
                  type="text"
                  label={"Email Address"}
                />
                <FormInputField
                  name="post-code"
                  style="bg-cblack7"
                  placeholder={"Enter Post code"}
                  form={form}
                  type="text"
                  label={"Post Code"}
                />
              </div>
              <FormInputField
                name="adress"
                style="bg-cblack7"
                placeholder={"Enter Your Address"}
                form={form}
                type="text"
                label={"Address"}
              />
              <div className="flex justify-between items-center gap-5 w-full flex-col md:flex-row">
                <FormInputField
                  name="contact-name"
                  style="bg-cblack7"
                  placeholder={"Enter key contact name"}
                  form={form}
                  type="text"
                  label={"Key Contact Name"}
                />
                <FormInputField
                  name="contact-phone"
                  style="bg-cblack7"
                  placeholder={"Enter phone number"}
                  form={form}
                  type="text"
                  label={"Key Contact phone number"}
                />
              </div>
              <FormInputField
                name="gender"
                style="bg-cblack7"
                placeholder={"Select here"}
                form={form}
                type="select"
                selectOption={[
                  {
                    label: "Restaurant",
                    value: "restaurant",
                  },
                  { label: "Takeaway", value: "takeaway" },
                   { label: "Cafe", value: "cafe" },
                    { label: "Pub", value: "pub" },
                     { label: "Bar", value: "bar" },
                      { label: "Other", value: "other" },
                ]}
                label={"Business Type"}
              />
              <div className="flex flex-col gap-2.5">
                <Label className="text-cwhite">Profile Picture</Label>
                <div className="w-full bg-cblack7 border border-gray-600 rounded-md ">
                  <Input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageChange}
                    className="w-full text-neutral-400 font-medium text-sm bg-cblack7 file:cursor-pointer cursor-pointer file:border-0 h-10 file:pt-1 file:px-4 file:mr-4 file:bg-transparent file:hover:bg-cblack7/50 file:text-neutral-400 rounded"
                  />

                  {images.length > 0 && (
                    <div className="flex flex-wrap gap-3 p-2">
                      {images.map((img) => (
                        <div
                          key={img.id}
                          className="relative group w-24 h-24 aspect-square rounded-lg overflow-hidden border"
                        >
                          <img
                            src={img.url}
                            alt="Preview"
                            className="w-full h-full object-cover"
                          />
                          <button
                            onClick={() => handleRemove(img.id)}
                            className="absolute top-1 right-1 bg-cyellow text-white p-1 rounded-full hover:bg-opacity-80"
                          >
                            <X size={16} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </form>
          </Form>
        </CardContent>
      </Card>
    </TabsContent>
  );
}

export default ClientDetailsTabs;

const dateSchema = z.object({
  date: z.string().min(1, "Date is required"),
});
